<script>
import SlideModal from '@components/modals/slide-modal'

export default {
  name: 'CostsDiscounts',
  components: {
    SlideModal
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      rightTurn: 0,
      upTurn: -0.25,
      billingInformation: '',
      paymentMethod: '',
      openedPanelCost: 0,
      openedPanelDiscounts: 0,
      showModal: false,
    }
  },
  computed: {
    rotationUp () {
      return {
        transform: `rotate(${this.upTurn}turn)`,
      }
    },
    rotationRight () {
      return {
        transform: `rotate(${this.rightTurn}turn)`,
      }
    },
  },
  methods: {
    showInfoIcon(type) {
      return type === 'serviceFee'
    }
  },
}
</script>

<template>
  <div
    v-if="componentData.show"
    :class="$style.container">
    <div :class="$style.test">
      <v-expansion-panel
        :class="$style.panel"
        v-model="openedPanelCost">
        <v-expansion-panel-content :class="$style.panel__container">
          <!-- Costs Section -->
          <div
            slot="header"
            :class="$style.panel__header"
          >
            <h6 :class="$style.panel__title">
              {{ $t('WIDGETS.COST_DISCOUNTS.COST_MESSAGE') }}
            </h6>
            <span
              :class="$style.panel__amount"
            >
              {{ componentData.costs.total.amount }}
            </span>
          </div>
          <div
            slot="actions"
            :class="$style.panel__action"
          >
            <img
              :class="$style.panel__action__icon"
              :style="openedPanelCost === 0 ? rotationUp : rotationRight"
              src="@assets/images/accordion/chevron_right.svg"
              alt=">"
            >
          </div>
          <div :class="$style.panel__body">
            <div :class="$style.panel__content">
              <!-- Costs Section -->
              <div v-if="componentData.costs.show">
                <div :class="$style.panel__content__subHeader">
                  <p>{{ $t('WIDGETS.COST_DISCOUNTS.COST_TITLE') }}</p>
                </div>
                <div
                  v-for="(item,i) in componentData.costs.items"
                  :class="$style.panel__contentRow"
                  :key="i"
                >
                  <div :class="$style.panel__contentRowDescription">
                    <p>
                      {{ item.description }}
                    </p>
                  </div>
                  <div
                    :class="$style.panel__contentRowAmount"
                    :style="{'justify-content': showInfoIcon(item.text) ? 'space-between' : 'flex-end'}"
                  >
                    <img
                      v-if="showInfoIcon(item.text)"
                      :class="$style.infoImage"
                      src="@assets/images/infoCircle.png"
                      @click="showModal = true"
                    >
                    <p>
                      {{ item.amount }}
                    </p>
                  </div>
                </div>
                <div :class="$style.panel__total">
                  <p :class="$style.panel__total__text">{{ componentData.costs.total.description }}</p>
                  <p :class="$style.panel__total__amount">{{ componentData.costs.total.amount }}</p>
                </div>
              </div>
              <!-- Discounts Section -->
              <div v-if="componentData.discounts.show">
                <div :class="$style.panel__content__subHeader">
                  <p>{{ $t('WIDGETS.COST_DISCOUNTS.DISCOUNT_TITLE') }}</p>
                </div>
                <div
                  v-for="(item,i) in componentData.discounts.items"
                  :class="$style.panel__contentRow"
                  :key="i"
                >
                  <div :class="$style.panel__contentRowDescription">
                    <p>{{ item.description }}</p>
                  </div>
                  <div
                    :class="$style.panel__contentRowAmount"
                    :style="{'justify-content': showInfoIcon(item.text) ? 'space-between' : 'flex-end'}"
                  >
                    <p>{{ item.amount }}</p>
                  </div>
                </div>
                <div :class="$style.panel__total">
                  <p :class="$style.panel__total__text">{{ componentData.discounts.total.description }}</p>
                  <p
                    :class="$style.panel__total__amount"
                    :style="{ 'color': componentData.discounts.total.amountColor }">{{ componentData.discounts.total.amount }}</p>
                </div>
              </div>
            </div>
            <!-- Total section -->
            <div
              v-if="componentData.total.show"
              :class="$style.total">
              <p
                :class="$style.total__text"
              >{{ componentData.total.title }}</p>
              <p
                :class="$style.total__amount"
              >{{ componentData.total.amount }}</p>

            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <SlideModal
        :active="showModal"
        :title="$t('WIDGETS.COST_DISCOUNTS.MODAL_SERVICE_FEE.TITLE')"
        :body="$t('WIDGETS.COST_DISCOUNTS.MODAL_SERVICE_FEE.TEXT')"
        :button="$t('WIDGETS.COMMON.UNDERSTOOD')"
        @closeModal="showModal = false"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.v-expansion-panel /deep/ div {
  border: 1px solid red !important;
}

.container {
  margin: $size-spacing-medium 0;
  background-color: transparent;
}

.panel {
  @include remove-borders;

  &__container {
    background-color: $background-container !important;
  }

  &__header {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    height: 3rem;
    margin: 0rem -0.8rem;
  }

  &__title {
    @extend %typography-large;

    font-weight: bold;
    margin-right: 20px;

  }

  &__amount {
    @extend %typography-medium;

    font-weight: bold;
    color: $darker-gray !important;
    margin-right: .5rem;
  }

  &__action {
    display: flex;
    margin-left: .5rem;
    margin-right: -1rem;

    &__icon {
      transition: transform 0.5s ease;
      max-width: 2rem;
    }
  }

  &__body {
    padding: 0 1rem;
  }

  &__content {
    padding: 1rem 0;
    border-top: 1px solid $divider-gray;

    &__subHeader {
      font-size: 1.2rem;
      color: $color-heading-text;
      padding: 1.2rem 0;
    }

    &Row {
      @extend %typography-small;

      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.6rem 0;
      border-bottom: 1px solid $divider-gray;
      font-size: $size-spacing-medium;
      font-weight: normal;

      &Description {
        display: flex;
        flex: 2 0 0;
        flex-flow: row wrap;
        justify-content: space-between;
        p {
          color: $secondary-text;
        }
      }

      &Amount {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        img {
          margin-right: .5rem;
          cursor: pointer;
        }
        p {
          color: $color-heading-text;
        }
      }
    }
  }

  &__total {

    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem 0;
    border-bottom: 1px solid $divider-gray;
    font-weight: 1.1rem;
    &__text {
      font-weight: normal;
      color: $color-heading-text;
    }
    &__amount {
      font-weight: $heading-font-weight;
    }
  }
}

.total {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 0;
  color: $color-heading-text;
  font-weight: 600;
  font-size: 1.2rem;
}

p {
  margin: 0;
}

.extramsg {
  font-size: 0.9rem;
  color: $cool-grey;
}

.infoImage {
  max-height: 1.4rem;
  max-width: 1.4rem;
  margin-left: 1rem;
}
</style>
